(() => {
  document.addEventListener("click", (event) => {
    const openMenu = document.querySelector(".mobile-menu[open]");
    if (!openMenu) return;

    const panel = openMenu.querySelector(".mobile-menu__panel");
    const toggle = openMenu.querySelector("summary");
    if (panel && !panel.contains(event.target) && toggle && !toggle.contains(event.target)) {
      openMenu.removeAttribute("open");
    }
  });

  const pauseSlideMedia = (slide) => {
    slide.querySelectorAll("video").forEach((video) => {
      if (!video.paused) video.pause();
    });
  };

  const initProductMediaGallery = (gallery) => {
    if (gallery.dataset.galleryInitialized === "true") return;

    const slides = Array.from(gallery.querySelectorAll("[data-product-media-slide]"));
    const thumbs = Array.from(gallery.querySelectorAll("[data-product-media-thumb]"));
    const prev = gallery.querySelector("[data-product-media-prev]");
    const next = gallery.querySelector("[data-product-media-next]");
    if (!slides.length) return;

    gallery.dataset.galleryInitialized = "true";
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));

    const setActive = (index) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        if (!isActive) pauseSlideMedia(slide);
        slide.hidden = !isActive;
        slide.classList.toggle("is-active", isActive);
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle("is-active", isActive);
        if (isActive) {
          thumb.setAttribute("aria-current", "true");
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
    };

    prev?.addEventListener("click", () => setActive(activeIndex - 1));
    next?.addEventListener("click", () => setActive(activeIndex + 1));

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        setActive(Number(thumb.dataset.mediaIndex || 0));
      });
    });

    gallery.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        setActive(activeIndex - 1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        setActive(activeIndex + 1);
      }
    });

    setActive(activeIndex);
  };

  document.querySelectorAll("[data-product-media-gallery]").forEach(initProductMediaGallery);
})();
